<template>
    <div class="p-4 bg-white shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center mb-4">
            <span class="text-2xl mr-2">📊</span>
            <span>Average GPA After Remedial/Foundation</span>
        </h2>

        <div v-if="hasData">
            <apexchart type="bar" height="300" :series="series" :options="chartOptions" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">⚠️</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GpaPerformanceAfterRemedial",
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        hasData() {
            return Array.isArray(this.data) && this.data.length > 0;
        },
        series() {
            return [
                {
                    name: "Students",
                    data: this.data.map((d) => d.avg_gpa || 0),
                },
            ];
        },
        chartOptions() {
            return {
                chart: {
                    type: "bar",
                    height: 300,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: "50%",
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        // const studentCount = this.data[opts.dataPointIndex].student_count || 0;
                        return `${val.toFixed(2)} GPA`;
                    },
                    style: {
                        fontSize: "12px",
                        colors: ["#000"],
                    },
                },
                xaxis: {
                    categories: this.data.map((d) => d.label),
                    title: { text: "Average GPA" },
                    labels: {
                        formatter: (val) => val.toFixed(1),
                    },
                },
                tooltip: {
                    shared: false, // since you have only one series, shared isn't required
                    intersect: false,
                    y: {
                        formatter: (val, opts) => {
                            const studentCount = this.data[opts.dataPointIndex].student_count || 0;
                            return `${studentCount}`;
                        },
                    },
                },
                colors: ["#4C78A8", "#F58518"],
                fill: {
                    type: "gradient",
                    gradient: {
                        shade: "light",
                        type: "horizontal",
                        shadeIntensity: 0.4,
                        gradientToColors: ["#86B7E0", "#FDC68B"],
                        inverseColors: false,
                        opacityFrom: 0.9,
                        opacityTo: 0.9,
                        stops: [0, 100],
                    },
                },
            };
        },
    },
};
</script>